import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import "./TravelManagement.css";
import Heading from "../../../utls/Heading";

const TravelManagement = () => {
  return (
    <>
      <div className="container travel-management-section">
        <div className="row px-lg-3">
          <div className="col-md-5 d-md-block d-none">
            <div className="travel-boy-img d-flex justify-content-xxl-center">
              <LazyLoadImage
                src="https://blueberrywebsites.azureedge.net/bbt/images/travelmanagement-img.png"
                alt=""
                loading="lazy"
              />
            </div>
          </div>

          <div className="col-md-7 col-12 travel-management">
            <Heading className="headings ">
              <span>Empower </span>Your Team with Effortless Travel
            </Heading>
            <p className="mt-4 travel-main-p">
              Simplify reservations and make sure company travel regulations are
              followed.
            </p>

            <div className="d-flex mt-lg-4 mt-3 gap-3 my-xxl-4 my-2">
              <LazyLoadImage
                src="https://blueberrywebsites.azureedge.net/bbt/images/travelm1.png"
                alt=""
                loading="lazy"
              />
              <div className="d-flex flex-column">
                <h4 className="fw-bold">Travel Policy Development</h4>
                <p className="grp-p">
                  Streamline bookings and ensure compliance with corporate
                  travel policies.
                </p>
              </div>
            </div>
            <div className="d-flex my-xxl-4 my-2 gap-3">
              <LazyLoadImage
                src="https://blueberrywebsites.azureedge.net/bbt/images/travelm2.png"
                alt=""
                loading="lazy"
              />
              <div className="d-flex flex-column">
                <h4 className="fw-bold">Expense Management</h4>
                <p className="grp-p">
                  Real-time tracking, management, and optimization of travel
                  expenditures.
                </p>
              </div>
            </div>
            <div className="d-flex my-2 gap-3">
              <LazyLoadImage
                src="https://blueberrywebsites.azureedge.net/bbt/images/travelm3.png"
                alt=""
                loading="lazy"
              />
              <div className="d-flex flex-column">
                <h4 className="fw-bold">Booking Solutions</h4>
                <p className="grp-p">
                  You can streamline the process with multichannel access to
                  hotels, flights, and other bookings.
                </p>
              </div>
            </div>
            <div className="d-flex my-xxl-4 my-2 gap-3">
              <LazyLoadImage
                src="https://blueberrywebsites.azureedge.net/bbt/images/travelm4.png"
                alt=""
                loading="lazy"
              />
              <div className="d-flex flex-column">
                <h4 className="fw-bold">Risk Management</h4>
                <p className="grp-p">
                  With proactive planning and real-time alerts, you can
                  guarantee the security of your workers.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TravelManagement;
